import type { ApiResponse } from '@/shared/types';
import api from '@/shared/api/client';

export const operatorAiApi = {
  getAiSettings: () => api.get<ApiResponse<any>>('/operator/ai/settings'),
  updateAiSettings: (data: { timeoutMs?: number }) =>
    api.patch<ApiResponse<any>>('/operator/ai/settings', data),

  listAiProviders: () => api.get<ApiResponse<any[]>>('/operator/ai/providers'),
  createAiProvider: (data: Record<string, unknown>) =>
    api.post<ApiResponse<any>>('/operator/ai/providers', data),
  updateAiProvider: (id: string, data: Record<string, unknown>) =>
    api.patch<ApiResponse<any>>(`/operator/ai/providers/${id}`, data),
  testAiProvider: (id: string) =>
    api.post<ApiResponse<any>>(`/operator/ai/providers/${id}/test`),

  listAiModels: () => api.get<ApiResponse<any[]>>('/operator/ai/models'),
  createAiModel: (data: Record<string, unknown>) =>
    api.post<ApiResponse<any>>('/operator/ai/models', data),
  updateAiModel: (id: string, data: Record<string, unknown>) =>
    api.patch<ApiResponse<any>>(`/operator/ai/models/${id}`, data),

  listAiPrompts: () => api.get<ApiResponse<any[]>>('/operator/ai/prompts'),
  createAiPrompt: (data: Record<string, unknown>) =>
    api.post<ApiResponse<any>>('/operator/ai/prompts', data),
  updateAiPrompt: (id: string, data: Record<string, unknown>) =>
    api.patch<ApiResponse<any>>(`/operator/ai/prompts/${id}`, data),
  publishAiPrompt: (id: string) =>
    api.post<ApiResponse<any>>(`/operator/ai/prompts/${id}/publish`),

  listAiCallLogs: (params?: Record<string, unknown>) =>
    api.get<ApiResponse<any>>('/operator/ai/call-logs', { params }),
};
